<template>
  <div class="container">
    <div class="header">
      <div class="title">留言板</div>
      <div class="typeList">
        <span>招生</span>
        <el-divider direction="vertical"></el-divider>
        <span>就业</span>
        <el-divider direction="vertical"></el-divider>
        <span>教学</span>
        <el-divider direction="vertical"></el-divider>
        <span>学生工作</span>
        <el-divider direction="vertical"></el-divider>
        <span>生活服务</span>
        <el-divider direction="vertical"></el-divider>
        <span>人才招聘</span>
        <el-divider direction="vertical"></el-divider>
        <span>出国留学</span>
        <el-divider direction="vertical"></el-divider>
        <span>报考问题咨询</span>
      </div>
    </div>
    <el-container>
      <el-main>
        <div class="list">
          <div class="list-item" v-for="(item, i) in messageList" :key="i">
            <div class="top">
              <div class="item-title">{{ item.title }}</div>
              <div class="time">{{ item.createTime }}</div>
            </div>
            <div class="item-content">
              {{ item.qcontent }}
            </div>
            <div class="reply">
              <span>回复：</span>
              {{ item.reply ? item.reply.rcontent : '' }}
            </div>
            <el-divider></el-divider>
          </div>
          <el-pagination background @current-change="handleCurrentChange" :page-size="limit" layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </el-main>
      <el-aside width="30%">
        <form class="form">
          <div class="form-item">
            <label>姓名</label>
            <el-input v-model="formInfo.username" placeholder=""></el-input>
          </div>
          <div class="form-item">
            <label>手机号</label>
            <el-input v-model="formInfo.telephone" placeholder=""></el-input>
          </div>
          <div class="form-item">
            <label>类别</label>
            <el-select v-model="formInfo.type" placeholder="请选择类别">
              <el-option v-for="item in typeList" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
          <div class="form-item">
            <el-input v-model="formInfo.title" placeholder="标题"></el-input>
          </div>
          <div class="form-item">
            <el-input type="textarea" :rows="5" resize="none" placeholder="请输入内容" v-model="formInfo.qContent">
            </el-input>
          </div>
          <div class="form-item">
            <el-input v-model="formInfo.code" placeholder="验证码"></el-input>
            <canvas class="codeCanvas" id="s-canvas" @click="drawPic" width="100" height="40"></canvas>
          </div>
          <div class="form-item">
            <el-button style="width:100%;margin-top:30px" @click="save" :loading="loading">立即留言</el-button>
          </div>
        </form>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'messageBoard',
  data () {
    return {
      messageList: [],
      formInfo: {
        username: '',
        telephone: '',
        type: '',
        title: '',
        qContent: '',
        code: ''
      },
      typeList: [
        { name: '招生' },
        { name: '就业' },
        { name: '教学' },
        { name: '学生工作' },
        { name: '生活服务' },
        { name: '人才招聘' },
        { name: '出国留学' },
        { name: '报考问题咨询' }
      ],
      identifyCodes: '1234567890',
      identifyCode: '',
      currentPage: 1,
      limit: 5,
      total: 0,
      loading: false
    }
  },
  mounted () {
    this.drawPic()
    this.getList()
  },
  methods: {
    // 生成一个随机数
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 四个数
    makeCode (l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    // 生成一个随机的颜色
    randomColor (min, max) {
      let r = this.randomNum(min, max)
      let g = this.randomNum(min, max)
      let b = this.randomNum(min, max)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    },
    drawPic () {
      this.identifyCode = ''
      this.makeCode(4)
      let canvas = document.getElementById('s-canvas')
      let ctx = canvas.getContext('2d')
      ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = this.randomColor(
        255,
        255
      )
      ctx.fillRect(0, 0, 100, 40)
      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }
      this.drawLine(ctx)
      this.drawDot(ctx)
    },
    drawText (ctx, txt, i) {
      ctx.fillStyle = this.randomColor(0, 200)
      ctx.font =
        this.randomNum(30, 40) + 'px SimHei'
      let x = (i + 1) * (100 / (this.identifyCode.length + 1))
      let y = this.randomNum(40, 40)
      var deg = this.randomNum(-40, 40)
      // 修改坐标原点和旋转角度
      ctx.translate(x, y)
      ctx.rotate((deg * Math.PI) / 180)
      ctx.fillText(txt, 0, 0)
      // 恢复坐标原点和旋转角度
      ctx.rotate((-deg * Math.PI) / 180)
      ctx.translate(-x, -y)
    },
    drawLine (ctx) {
      // 绘制干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.randomColor(
          100,
          255
        )
        ctx.beginPath()
        ctx.moveTo(
          this.randomNum(0, 100),
          this.randomNum(0, 40)
        )
        ctx.lineTo(
          this.randomNum(0, 100),
          this.randomNum(0, 40)
        )
        ctx.stroke()
      }
    },
    drawDot (ctx) {
      // 绘制干扰点
      for (let i = 0; i < 40; i++) {
        ctx.fillStyle = this.randomColor(0, 255)
        ctx.beginPath()
        ctx.arc(
          this.randomNum(0, 100),
          this.randomNum(0, 40),
          1,
          0,
          2 * Math.PI
        )
        ctx.fill()
      }
    },
    getList () { // 获取留言列表
      let para = {
        page: this.currentPage,
        rows: this.limit
      }
      this.$http.getMessagesList(para).then(res => {
        console.log(res)
        this.messageList = res.list
        this.total = res.total
        this.currentPage = res.pageNum
      }).catch(err => {
        console.error(err)
      })
    },
    handleCurrentChange (e) { // 分页
      this.currentPage = e
      this.getList()
    },
    save () { // 留言
      this.loading = true
      if (this.formInfo.username === '' || this.formInfo.telephone === '' || this.formInfo.type === '' || this.formInfo.title === '' || this.formInfo.qContent === '' || this.formInfo.code === '') {
        this.$message({
          showClose: true,
          message: '请完善所有信息',
          type: 'error'
        })
        this.loading = false
        return false
      }
      const reg = /^1[0-9]\d{9}$/
      if (!reg.test(this.formInfo.telephone)) {
        this.$message({
          showClose: true,
          message: '请输入正确手机号',
          type: 'error'
        })
        this.loading = false
        return false
      }
      if (this.formInfo.code !== this.identifyCode) {
        this.$message({
          showClose: true,
          message: '验证码不正确',
          type: 'error'
        })
        this.loading = false
        return false
      }
      this.$http.createMessage(this.formInfo).then(res => {
        console.log(res)
        if (res.success) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          })
          this.formInfo = {
            name: '',
            telphone: '',
            type: '',
            title: '',
            content: '',
            code: ''
          }
          this.drawPic()
        }
        this.loading = false
      }).catch(err => {
        console.error(err)
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color: #6e348b;

.header {
  display: flex;
  align-items: flex-end;
  padding: 20px;

  .title {
    color: $color;
    font-size: 24px;
    font-weight: bold;
    margin-right: 20px;
  }

  .typeList {
    font-size: 14px;
  }
}

.el-container {
  display: flex;
  padding: 20px;

  .el-main {
    border: 1px solid $color;
    position: relative;
    padding-bottom: 40px;

    .list-item {
      margin-bottom: 20px;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .item-title {
          font-weight: bold;
        }

        .time {
          color: #909399;
          font-size: 14px;
        }
      }

      .item-content {
        color: #606266;
        font-size: 14px;
      }

      .reply {
        color: #606266;
        font-size: 14px;

        span {
          color: #333;
          font-weight: bold;
        }
      }
    }
  }

  .el-aside {
    background: $color;
    margin-left: 20px;
    min-width: 350px;

    .form {
      padding: 10px 20px;

      .form-item {
        display: flex;
        align-items: center;
        margin: 20px 0;

        .el-input,
        .el-select {
          flex: 1;
        }

        label {
          width: 75px;
          color: #fff;
        }

        canvas {
          margin-left: 10px;
        }
      }
    }
  }
}

.el-divider--horizontal {
  margin: 5px 0;
}

.el-pagination.is-background {
  text-align: center;
  position: absolute;
  bottom: 10px;
  width: calc(100% - 40px);
}
</style>



// WEBPACK FOOTER //
// src/views/messageBoard.vue